import React from "react";
import { Box, Container, Typography } from "@mui/material";
import AdminUsers from "../components/AdminUsers";

const AdminUsersPage: React.FC = () => (
  <Container>
    <Box sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        Admin User Management
      </Typography>
      <AdminUsers />
    </Box>
  </Container>
);

export default AdminUsersPage;
